// extracted by mini-css-extract-plugin
export default {"contact__search":"ContactDetails_contact__search__JJVii"};